<div>
  <h1 class="my-account-h1--dark">{{ 'home.title' | translate }}</h1>
  <h2 class="home-subtitle--light">{{ 'home.hello' | translate }} {{ name }}</h2>
</div>
